<template>
    <div :style="{ backgroundColor: isBlur ? '' : '#fff', color: isExpert ? '#fff' : '' }" style="display:flex; justify-content: center; margin-top: 18px; margin-bottom: 16px; position: relative; align-items: center;">
        <div style="flex:1; padding: 0 12px; display:flex; align-items: center; " @click="closeAction">
            <img v-if="!isSecret" :src="require('@/assets/img/ico-move_black.png')" style="width: 10px;">
            <img v-else :src="require('@/assets/img/ico-move_white.png')" style="width: 10px;">
            <span style="font-size:14px; font-weight:500; margin-left:5px;">{{ backTitle }}</span>
        </div>
        <div v-if="title !== ''" style="display:grid;place-items: center; font-weight:bold; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -55%); font-size:16px;" :style="{ flex: title ? null : 1, }">{{ title }}</div>
        <div style="flex:1;">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "MercenaryHeader",
    props: {
        title: {
            type: String,
            default: '',
        },
        isSecret: {
            type: Boolean,
            default: false
        },
        closeAction: {
            type: Function,
            default: () => { }
        },
        backTitle: {
            type: String,
            default: '',
        },
        backgroundColor: {
            type: String,
            default: '#fff'
        },
        isBlur: {
            type: Boolean,
            default: false
        },
        isExpert: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped></style>